// extracted by mini-css-extract-plugin
export default {"grid":"Homepage_grid__7Krgb","contentCard":"Homepage_contentCard__nmv7+","small":"Homepage_small__pOLGx"};